import axiosInstance from "../lib/axios";

// Item pada list customer (GET /Customer/List) -- key pakai camelCase
// sesuai response dari list/service.ts di backend.
export interface CustomerOption {
  id: number;
  customerName: string;
  companyName: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  npwp: string | null;
  status: string;
}

// Detail customer (GET/POST/PUT by id) -- key pakai snake_case sesuai
// response dari create/edit/detail service.ts di backend.
export interface CustomerDetail {
  id: number;
  customer_name: string;
  company_name: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  npwp: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerPayload {
  customer_name: string;
  company_name?: string;
  address?: string;
  phone?: string;
  email?: string;
  npwp?: string;
  status?: string;
}

interface GetCustomerRequest {
  page?: number;
  limit?: number;
}

export const getCustomer = async ({
  page = 1,
  limit = 10,
}: GetCustomerRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Customer/List", body);

  return data;
};

export const createCustomer = (payload: CustomerPayload) => {
  return axiosInstance.post("/Customer/Create", payload);
};

export const getCustomerById = (id: number) => {
  return axiosInstance.get(`/Customer/${id}`);
};

export const editCustomer = (id: number, payload: CustomerPayload) => {
  return axiosInstance.put(`/Customer/${id}`, payload);
};

export const deleteCustomerById = (id: number) => {
  return axiosInstance.delete(`/Customer/${id}`);
};
